<style lang="less" >
  @import "./ChangeDev.less";
</style>

<template>
  <div class="change-dev">
    <van-cell-group>
      <van-cell title="当前IMEI" icon="setting-o" :value="selectDev || nowDev" is-link @click="selectDevFn" />
    </van-cell-group>
    <div class="page-btn">
      <van-button type="info" size="large" @click="changeDevFn">切换设备</van-button>
    </div>
    <!-- 选择设备号 -->
    <van-action-sheet
      v-model="showActionSheetDev"
      title="请选择设备号"
      round
      :actions="devList"
      cancel-text="取消"
      @select="onSelectDevFn"
      @cancel="onCancel"
      @click-overlay="onCancel"
    />
  </div>
</template>

<script>
import ChangeDev from './ChangeDev.js'
export default {
  ...ChangeDev
}
</script>
